export default __webpack_public_path__ + "static/media/logo-lg-light.f9840ba7.svg";